export const returnParseArray = (val: string) => {
  const start = val.indexOf('['); // Find the index where the array starts
  const end = val.indexOf(']'); // Find the index where the array ends

  if (!end || end === -1) return '';

  const arrayString = val.substring(start, end + 1); // Extract the array string

  return JSON.parse(arrayString);
};

export const cleanAndStripHTML = (data: string) => {
  if (typeof data === 'string') {
    // Strip HTML tags and trim the result
    const text = data.replace(/<[^>]+>/g, '').trim();
    return text === '' ? undefined : text;
  }

  return data; // Return numbers, booleans, etc. as-is
};

export const cleanSalesKit = (data: any) => {
  const kit = data?.data?.flatMap((item: any) =>
    !!item?.data && Array.isArray(item?.data)
      ? item?.data?.map((entry: any) => ({
          name: typeof entry.name === 'string' ? entry.name : '',
          content:
            typeof entry.content === 'string'
              ? cleanAndStripHTML(entry.content)
              : ''
        }))
      : ''
  );

  return JSON.stringify(kit);
};

type ProductData = {
  core_identifiers?: Record<string, any>;
  custom_attributes?: any[];
  descriptions?: Record<string, any>;
  logistics_and_packaging?: Record<string, any>;
  physical_specifications?: Record<string, any>;
  search_and_seo?: Record<string, any>;
  usage_and_attributes?: Record<string, any>;
  [key: string]: any;
};

export const extractMetadata = (data: ProductData): ProductData => {
  const keysToExtract = [
    'core_identifiers',
    'custom_attributes',
    'descriptions',
    'logistics_and_packaging',
    'physical_specifications',
    'search_and_seo',
    'usage_and_attributes'
  ];

  const isEmpty = (value: any): boolean => {
    if (value === '' || value === null || value === undefined) return true;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === 'object') return Object.keys(value).length === 0;
    return false;
  };

  const removeEmptyValues = (obj: Record<string, any>): Record<string, any> =>
    Object.fromEntries(
      Object.entries(obj).filter(([_, value]) => !isEmpty(value))
    );

  const result: ProductData = {};

  keysToExtract.forEach(key => {
    const section = data[key];
    if (section && typeof section === 'object') {
      const cleaned = removeEmptyValues(section);
      if (Object.keys(cleaned).length > 0) {
        result[key] = cleaned;
      }
    } else if (Array.isArray(section) && section.length > 0) {
      result[key] = section;
    }
  });

  return result;
};
